import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { percomaticLoadedState, percomaticState } from '../atoms';
import { cartQuantityState } from '../Cart/atoms';
import { Loader } from '../components/Loader';
import {
	clearCheckoutSlice,
	setBalanceDue,
	setCartTotalPlusTax
} from '../domains/Checkout/slice';
import { Container } from '../GlobalComponents/Container';
import { Flex } from '../GlobalComponents/Flex';
import { Outer } from '../Layout/Router/Outer';
import { useAppDispatch } from '../reduxstore/hooks';
import { storeState } from '../Store/atoms';
import { StoreFieldsFragment } from '../Store/graphql';
import { Layout } from './components/Layout';
import { StripeProvider } from './components/StripeProvider';
import { Login } from './views/Login';
import { Payment } from './views/Payment';
import { PaymentOption } from './views/PaymentOption';
import { Pickup } from './views/Pickup';
import { Profile } from './views/Profile';

//////////
//////// START HERE //////////
//////////

export const Checkout: React.FC = () => {
	const store = useRecoilValue(storeState);
	const dispatch = useAppDispatch();

	const percState = useRecoilValue(percomaticState);

	const { currentTrans } = percState.ui.homeScreenHandler.orderScreenHandler;

	useEffect(() => {
		// reset checkout on unmount
		return () => {
			dispatch(clearCheckoutSlice());
			dispatch(setCartTotalPlusTax(currentTrans?.total));
			dispatch(setBalanceDue(currentTrans?.total));
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const percomaticLoaded = useRecoilValue(percomaticLoadedState);
	const cartQuantity = useRecoilValue(cartQuantityState);

	if (percomaticLoaded && cartQuantity === 0) {
		return <Navigate to="/" replace />;
	}

	return (
		<Flex $justifyContent="center">
			<Container width="1140">
				<StripeProvider>
					<Layout>
						<Routes>
							<Route path="/" element={<Outer />}>
								<Route
									path="/login"
									element={
										<Loader title="/login">
											<Login />
										</Loader>
									}
								/>

								<Route
									path="/profile"
									element={
										<Loader title="/profile">
											<Profile />
										</Loader>
									}
								/>

								<Route
									path="/pickup"
									element={
										<Loader title="/pickup">
											<Pickup />
										</Loader>
									}
								/>
								<Route
									path="/payment-options"
									element={
										<Loader title="/payment-options">
											<PaymentOption />
										</Loader>
									}
								/>

								<Route
									path="/payment"
									element={
										<Loader title="/payment">
											<Payment
												store={
													store as StoreFieldsFragment
												}
											/>
										</Loader>
									}
								/>
								<Route
									path="/"
									element={<Navigate to="login" replace />}
								/>
								<Route
									path="/*"
									element={<Navigate to="." replace />}
								/>
							</Route>
						</Routes>
					</Layout>
				</StripeProvider>
			</Container>
		</Flex>
	);
};
